import { useState } from "react";

import PropTypes from "prop-types";
// import Mui components
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
// import mui icons
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadOverallRemovedKpiListState,
    loadAgreementRemovedKpiListState,
    loadClaimsRemovedKpiListState,
    loadJustRightRemovedKpiListState,
    loadSecondaryRemovedKpiListState,
    loadFragranceMetricsRemovedKpiListState,
    loadPreferenceRemovedKpiListState,
} from "../../../../store/features/analysisKpiSlice";

// components
import RemoveRestoreButton from "./RemoveRestoreButton";

function RemoveRestoreDialog({ settings, functionsSettings, analysisView }) {
    const { openRestoreDialog, removedKpi, showCheckBox, disableRestore } = settings;
    const { setOpenRestoreDialog } = functionsSettings;
    const { moduleName, mappings } = analysisView;
    const backendVariableSettings = {
        removedKpi: removedKpi,
        showCheckBox: showCheckBox,
        disableRestore: disableRestore,
    };

    const theme = useTheme();
    const dispatch = useDispatch();
    const displayLabelTransition = useSelector((state) => state.dataMappingStore.displayLabelTranslation);

    const [selectAllRestore, setSelectAllRestore] = useState(false);
    const [reStoreKpi, setReStoreKpi] = useState([]);
    const [disableSubmitButton, setDisableSubmitButton] = useState(true);

    const getLabel = (datum) => {
        if (moduleName === "claims") {
            const filterArr = mappings.filter((ele) => ele?.displayLabels[0].backendVariable == datum);
            return filterArr[0]?.displayLabels[0].displayLabel;
        } else {
            const splitKeys = datum.split(",");
            return displayLabelTransition[splitKeys[0]];
        }
    };

    const renderRemovedListCheckboxes = () => {
        // const list = getRemovedList();
        return removedKpi.map((datum, i) => {
            const label = getLabel(datum);

            const key = i + 1;
            return (
                <FormControlLabel
                    key={key}
                    sx={{
                        "& .MuiTypography-root": {
                            fontSize: 14,
                            color: "#495057",
                            padding: 0,
                        },
                        borderRadius: "5px",
                        width: "100%",
                        margin: "3px 0px",
                        padding: "0px",
                        color: reStoreKpi.includes(datum) ? theme.palette.primary.main : theme.palette.text.primary,
                        background: reStoreKpi.includes(datum) ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                    }}
                    control={
                        <Checkbox
                            sx={{
                                "& .MuiSvgIcon-root": {
                                    fontSize: 18,
                                },
                                padding: "6px",
                            }}
                            color="secondary"
                            id={`${datum}-${i}`}
                            checked={reStoreKpi.includes(datum) ? reStoreKpi.includes(datum) : false}
                            onChange={handleSetRestoreKpi}
                            value={datum}
                            name={`${datum}-${i}`}
                        />
                    }
                    label={label}
                />
            );
        });
    };

    const handleRestoreVariables = () => {
        if (removedKpi.length === reStoreKpi.length) {
            if (moduleName === "overall") {
                dispatch(loadOverallRemovedKpiListState([]));
            } else if (moduleName === "secondary") {
                dispatch(loadSecondaryRemovedKpiListState([]));
            } else if (moduleName === "agreement") {
                dispatch(loadAgreementRemovedKpiListState([]));
            } else if (moduleName === "claims") {
                dispatch(loadClaimsRemovedKpiListState([]));
            } else if (moduleName === "justRight") {
                dispatch(loadJustRightRemovedKpiListState([]));
            } else if (moduleName === "fragranceMetrics") {
                dispatch(loadFragranceMetricsRemovedKpiListState([]));
            } else if (moduleName === "preference") {
                dispatch(loadPreferenceRemovedKpiListState([]));
            }
        } else {
            const kpis = removedKpi.filter((ele) => !reStoreKpi.includes(ele));
            if (moduleName === "overall") {
                dispatch(loadOverallRemovedKpiListState(kpis));
            } else if (moduleName === "secondary") {
                dispatch(loadSecondaryRemovedKpiListState(kpis));
            } else if (moduleName === "agreement") {
                dispatch(loadAgreementRemovedKpiListState(kpis));
            } else if (moduleName === "claims") {
                dispatch(loadClaimsRemovedKpiListState(kpis));
            } else if (moduleName === "justRight") {
                dispatch(loadJustRightRemovedKpiListState(kpis));
            } else if (moduleName === "fragranceMetrics") {
                dispatch(loadFragranceMetricsRemovedKpiListState(kpis));
            } else if (moduleName === "preference") {
                dispatch(loadPreferenceRemovedKpiListState(kpis));
            }
        }
        setReStoreKpi([]);
        handleRestoreDialogClose();
        setSelectAllRestore(false);
    };

    const handleSetRestoreKpi = (chkBox) => {
        const value = chkBox.target.value;
        const isChecked = chkBox.target.checked;
        let prevKpi = [...reStoreKpi];

        if (isChecked) {
            if (value === "All") {
                setReStoreKpi(removedKpi);
                setSelectAllRestore(true);
                setDisableSubmitButton(false);
                return;
            }
            prevKpi.push(value);
            setReStoreKpi(prevKpi);
            setSelectAllRestore(removedKpi.length === prevKpi.length);
            setDisableSubmitButton(false);
            return;
        }

        // Unchecked logic
        if (value === "All") {
            setReStoreKpi([]);
            setSelectAllRestore(false);
            setDisableSubmitButton(true);
            return;
        }

        prevKpi = reStoreKpi.filter((ele) => ele != value);

        setReStoreKpi(prevKpi);
        setDisableSubmitButton(prevKpi.length === 0);
        setSelectAllRestore(false);
    };

    const handleRestoreDialogClose = () => {
        setReStoreKpi([]);
        setSelectAllRestore(false);
        setOpenRestoreDialog(false);
    };
    return (
        <>
            {openRestoreDialog && (
                <Dialog
                    open={openRestoreDialog}
                    onClose={handleRestoreDialogClose}
                    fullWidth={true}
                    sx={{ "& .MuiDialog-paper": { width: "80%", minHeight: 300, maxHeight: 450 } }}
                    maxWidth="sm"
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        // className="liner-light-blue-background-2"
                        id="alert-dialog-title"
                    >
                        The following variables were removed from the Analysis :
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 2,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleRestoreDialogClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div
                            style={{
                                minHeight: 150,
                                maxHeight: 350,
                                margin: "20px",
                                padding: "20px",
                            }}
                        >
                            <div>
                                <FormControlLabel
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: 14,
                                            color: "#495057",
                                            padding: 0,
                                        },
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "3px 0px",
                                        padding: "0px",
                                        color: selectAllRestore ? theme.palette.primary.main : theme.palette.text.primary,
                                        background: selectAllRestore ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                                    }}
                                    control={
                                        <Checkbox
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: 18,
                                                },
                                                padding: "6px",
                                            }}
                                            color="secondary"
                                            id={`${"All"}`}
                                            checked={selectAllRestore}
                                            onChange={handleSetRestoreKpi}
                                            value={"All"}
                                            name={"All"}
                                        />
                                    }
                                    label={"Select All"}
                                />
                            </div>
                            <div
                                style={{
                                    marginLeft: 10,
                                }}
                            >
                                {renderRemovedListCheckboxes()}
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            paddingBottom: "20px",
                        }}
                    >
                        <p
                            style={{
                                color: "#000000",
                                fontSize: "0.75rem",
                                fontWeight: "700",
                                margin: "0px 100px",
                                textAlign: "center",
                                paddingBottom: "20px",
                            }}
                        >
                            Are you sure you want to restore these variables?
                        </p>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                size="small"
                                className={"custom-btn custom-btn-outlined"}
                                variant="outlined"
                                onClick={handleRestoreDialogClose}
                                style={{
                                    margin: "5px 10px",
                                }}
                            >
                                No
                            </Button>
                            <Button
                                size="small"
                                className={disableSubmitButton ? "custom-btn  disabled" : "custom-btn custom-btn-outlined"}
                                variant="outlined"
                                onClick={handleRestoreVariables}
                                disabled={disableSubmitButton}
                                style={{
                                    margin: "5px 10px",
                                }}
                            >
                                Yes
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            )}
            <RemoveRestoreButton
                backendVariableSettings={backendVariableSettings}
                functionsSettings={functionsSettings}
                analysisView={analysisView}
            />
        </>
    );
}

RemoveRestoreDialog.propTypes = {
    settings: PropTypes.object,
    functionsSettings: PropTypes.object,
    analysisView: PropTypes.object,
};

export default RemoveRestoreDialog;
